import React from "react"
import { Card, Grid, Icon } from "semantic-ui-react"
import { ReactComponent as CollegeIcon } from "uikit/Icons/college-goal.svg"

const Education = () => (
  <Card>
    <Card.Content>
      <Grid>
        <Grid.Row columns="equal">
          <Grid.Column verticalAlign="middle" width={4}>
            <CollegeIcon width="80px" />
          </Grid.Column>
          <Grid.Column>
            <p style={{ fontWeight: "bold" }}>Save for College</p>
            <p className="greyed-text">
              <Icon name="check" color="green" />
              Jack Jr.
            </p>
            <p className="greyed-text">
              <Icon name="check" color="green" />
              Sarah
            </p>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Card.Content>
  </Card>
)

export default Education
